import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { api } from "../../api";
import { InvestmentStrategy } from "../../api/admin";

interface InvestmentState {
    strategies: InvestmentStrategy[];
    isLoading: boolean;
    error: string | null;
}

const initialState: InvestmentState = {
    strategies: [],
    isLoading: false,
    error: null,
};

export const investmentSlice = createSlice({
    name: "investment",
    initialState,
    reducers: {
        setStrategies: (state, action: PayloadAction<InvestmentStrategy[]>) => {
            state.strategies = action.payload;
        },
    },
    extraReducers: (builder) => {
        // We can use RTK Query matching if we want, or just handle manually
        // But better to use RTK Query directly in components.
        // If the user wants a store, we can use this to keep "current" strategies list.
    },
});

export const { setStrategies } = investmentSlice.actions;
export default investmentSlice.reducer;
